import { ClientUsersClient } from '@src/clientUser/manage/ClientUsersClient';
import { useMutation } from '@tanstack/react-query';

export const useReactivateClientUser = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  const { mutate: reactivate, isPending: isReactivating } = useMutation({
    mutationFn: ({
      clientUserId,
      clientId,
    }: {
      clientUserId: string;
      clientId: string;
    }) => ClientUsersClient.reactivate(clientUserId, clientId),
    onSuccess,
  });
  return {
    reactivate,
    isReactivating,
  };
};
